<div
  *ngFor="let year of years"
  class="phx-year-picker-body-year-cell"
  phxFocusableItem
  (click)="onSelectYear(year)"
  (keydown)="onKeydown(year, $event)"
  [class.phx-year-picker-body-current-year]="isCurrentYear(year)"
>
  <span>{{ year.getFullYear() }}</span>
</div>
